<div class="feedbackModalContainer">
    <div class="feedbackModalHeader mb-3 d-flex justify-content-between">
        <div class="feedbackModalHeaderText mt-1">
            <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Submit_Feedback">Submit Feedback</span>
        </div>
        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail mt-n5 mr-n4" style="outline: 0 !important" (click)="close()">
            <svg class="icon-16">
                <use href="../../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
            </svg>
        </button>
    </div>

    <div class="flex-fill mb-3" [ngClass]="!(isSubmitted || isError) ? 'feedbackModalBodyForm' : 'feedbackModalBodyMessage'">
        <div [hidden]="isSubmitted" name="feedbackForm" class="flex-fill px-5">
            <div class="feedbackModalFormInfo my-3">
                <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Description_Line_1">
                    Please tell us what we're doing well, and what we can do better.
                </span> <br />
                <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Description_Line_2">
                    We appreciate your honest feedback!
                </span>
            </div>
            <div class="form-group my-7">
                <label class="feedbackModalFormLabel feedbackModalFeelingLabelText text-center w-100" cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Prompt">
                    Choose an expression to tell us how you feel:
                </label>
                <div class="feedbackModalFeelingHolder mt-2">
                    <div class="feedbackModalFeeling feedbackModalFeelingNotAFan" (click)="selectRating(1)" [ngClass]="{'active': rating === 1}"></div>
                    <div class="feedbackModalFeeling feedbackModalFeelingMeh" (click)="selectRating(2)" [ngClass]="{'active': rating === 2}"></div>
                    <div class="feedbackModalFeeling feedbackModalFeelingSoSo" (click)="selectRating(3)" [ngClass]="{'active': rating === 3}"></div>
                    <div class="feedbackModalFeeling feedbackModalFeelingLikeIt" (click)="selectRating(4)" [ngClass]="{'active': rating === 4}"></div>
                    <div class="feedbackModalFeeling feedbackModalFeelingLoveIt" (click)="selectRating(5)" [ngClass]="{'active': rating === 5}"></div>
                </div>
                <div class="feedbackModalFeelingHolder my-2">
                    <div class="feedbackModalFeelingText">
                        <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Not_a_fan">Not a fan</span>
                    </div>
                    <div class="feedbackModalFeelingText">
                        <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Meh">Meh</span>
                    </div>
                    <div class="feedbackModalFeelingText">
                        <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="So_so">So-so</span>
                    </div>
                    <div class="feedbackModalFeelingText">
                        <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Like_it">Like It</span>
                    </div>
                    <div class="feedbackModalFeelingText">
                        <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Love_it">Love It</span>
                    </div>
                </div>
                <div *ngIf="showRatingError" class="feedbackModalRatingError text-danger text-center mt-2">
                    <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Expression_Error">
                        Please choose an expression.
                    </span>
                </div>
            </div>
    
            <div class="form-group my-3 flex-fill">
                <label class="feedbackModalFormLabel" cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Reason_Prompt">
                    Why do you feel that way?
                </label>
                <textarea 
                    id="reasonBody"
                    name="reason"
                    required 
                    class="feedbackTextArea form-control fontSize14" 
                    [ngClass]="{'is-invalid': !suppressReasonError}"
                    [(ngModel)]="body"
                    (ngModelChange)="onBodyChanged()"
                    maxlength="3072"
                    resize="false"
                    placeholder="Type reason here"
                    cvLocalizedPlaceholder
                    langSection="Submit_Feedback_Popup"
                    langKey="Reason_Placeholder"></textarea>
                 <div *ngIf="!suppressReasonError && body.trim().length <= 0" class="invalid-feedback">
                    <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Reason_Error">
                        Please enter a reason.
                    </span>
                </div>
            </div>
        </div>

        <div class="feedbackModalMessage flex-fill">
            <div *ngIf="isSubmitted && success" class="feedbackModalMessageSection">
                <span class="feedbackModalSuccessText text-success" cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Submit_Success">
                    Submitted Successfully
                </span>
            </div>
            <div *ngIf="isSubmitted && !success" class="feedbackModalMessageSection">
                <div class="feedbackModalErrorText text-danger" cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Submit_Error">
                    Submit Failed
                </div>
                <div class="pt-1">
                    <a href="#" class="text-primary" (click)="initialize(true); $event.preventDefault();" cvLocalizedText langSection="Submit_Feedback_Popup" langKey="Go_Back">
                        Go back
                    </a>
                    <span>&nbsp;</span>
                    <span cvLocalizedText langSection="Submit_Feedback_Popup" langKey="And_try_Again">
                        and try again.
                    </span>
                </div>
            </div>
        </div>
        
    </div>

    <div class="feedbackModalFooter pt-3">
        <button type="button" [hidden]="isSubmitted" class="btn btn-text mr-2" cvLocalizedText langSection="Common" langKey="Cancel_Button" (click)="close()">Cancel</button>
        <button type="button" [hidden]="isSubmitted" class="btn btn-primary" [ngClass]="isSubmitting ? 'disabled' : 'btn-primary'" (click)="submitFeedback()" cvLocalizedText langSection="Common" langKey="Submit_Button">Submit</button>
        <button type="button" *ngIf="isSubmitted" class="btn btn-text mr-2" cvLocalizedText langSection="Common" langKey="Close" (click)="close()">Close</button>
    </div>
</div>
